// src/components/InternetCheckModal.tsx
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import BaseButton from "@/components/base/button/BaseButton.tsx";
import {Portal} from "react-portal";
import {cn} from "@/lib/utils.ts";

interface InternetCheckModalProps {
  isOpen: boolean;
  onRetry: () => void;
}

const InternetCheckModal: React.FC<InternetCheckModalProps> = ({ isOpen,onRetry }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleRetry = async () => {
    setIsLoading(true);
    try {
      await new Promise((resolve) => setTimeout(resolve, 500));
      await onRetry();
    } finally {
      setIsLoading(false);
    }
  };

  return (
      <Portal>
        <div
            className={cn("fixed inset-0 bg-dark/80  flex justify-center items-center z-50", !isOpen && 'hidden')}>
          <div
              className="bg-[linear-gradient(150deg,_#45454D_0%,_#14141E_72.24%)] p-4 rounded-lg text-center grid items-center justify-center max-w-[310px] w-full shadow-lg relative before:rounded-lg before:absolute before:inset-0 before:border-2 before:border-white/08 before:pointer-events-none">
            <img className="w-[100px] h-[100px] mx-auto" src="images/patterns/no-internet.webp" alt="No internet."/>
            <h2 className="text-2xl font-extrabold text-white leading-130 my-2">
              {t("no_connection")}
            </h2>
            <p className="text-sm text-white/70 leading-130 mb-8">{t("no_connection_desc")}</p>
            <BaseButton
                text={t("retry")}
                onClick={handleRetry}
                isLoading={isLoading}
            />
          </div>
        </div>
      </Portal>
  );
};

export default InternetCheckModal;